import type Option from '@modules/husleie-framework/src/types/Option.entity';
import type { UserTranslationOptions } from '@modules/store/user/types/UserTranslationOptions.entity';

export default class UserStringOperations {
  static getAppellationTranslation(
    options: UserTranslationOptions,
    appellation: undefined | string
  ): undefined | string {
    return options && appellation && appellation !== 'DIVERSE'
      ? UserStringOperations.getTranslation(options, appellation)
      : undefined;
  }

  static getTitleTranslation(options: UserTranslationOptions, title: undefined | string): undefined | string {
    return options && title
      ? UserStringOperations.getTranslation(options, title)
      : undefined;
  }

  static getFullName(
    appellation: undefined | string,
    title: undefined | string,
    firstName: string,
    lastName: string,
    indirect = false
  ): string {
    if (indirect) {
      // person is addressed in an indirect way, change the way we address him/her
      appellation = '';
    } else if (appellation || title) firstName = '';

    return [appellation, title, firstName, lastName].filter(entry => entry).join(' ');
  }

  private static getTranslation(options: UserTranslationOptions, value: undefined | string): undefined | string {
    if (value && options.appellationOptions && options.appellationOptions.length) {
      const entry = options.appellationOptions.find((e: Option) => e.name === value);
      return entry ? (entry.value as string) : undefined;
    }
  }
}
